import { CDN_URL_IMAGES } from '@/configs';

export const SEO_TITLE = 'Alpha';
export const SEO_DESCRIPTION =
  'The crypto super app that brings crypto to the mainstream.';
export const SEO_IMAGE = `${CDN_URL_IMAGES}/alpha_metadata_06.png`;
